import React from "react"
import { Navigate } from "react-router-dom"

// Auth pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Vendor Pages
import { Products as VendorProducts } from "pages/vendor/Products"
import { Orders as VendorOrders } from "pages/vendor/Orders/Orders"
import { Coupons as VendorCoupons } from "pages/vendor/Coupons"
import { Categories as VendorCategories } from "pages/vendor/Categories"
import { DeliveryMen as VendorDeliveryMen } from "pages/vendor/Delivery-men"
import {
  Customers as VendorCustomers,
  AreaActive as VendorAreaActive,
  NewThisMonth as VendorNewThisMonth,
  CustomersBundles as VendorCustomersBundles,
} from "pages/vendor/Customers"
import { Disputes as VendorDisputes } from "pages/vendor/Disputes"
import { Campaigns as VendorCampaigns } from "pages/vendor/Campaigns"
import {
  Dashboard as VendorDashboard,
  TopProductsBySell as VendorTopProductsBySell,
} from "pages/vendor/Dashbaord"
import VendorOrder from "pages/vendor/Orders/Order"
import VendorCategoryDetails from "pages/vendor/Categories/CategoryDetails"
import VendorCouponDetails from "pages/vendor/Coupons/CouponDetails"
import VendorProductDetails from "pages/vendor/Products/ProductDetails"
import VendorDeliveryManDetails from "pages/vendor/Delivery-men/DeliveryManDetails"
import VendorDisputeDetails from "pages/vendor/Disputes/DisputeDetails"
import VendorCampaignDetails from "pages/vendor/Campaigns/CampaignDetails"
import VendorSettings from "pages/vendor/Settings/Settings"
import VendorOffers from "pages/vendor/Offers/Offers"
import VendorOfferDetails from "pages/vendor/Offers/OfferDetails"
import {  Revenue as VendorRevenue } from "pages/vendor/Revenue"


// Admin Pages
import { Products as AdminProducts } from "pages/admin/Products"
import { Orders as AdminOrders } from "pages/admin/Orders/Orders"
import { Coupons as AdminCoupons } from "pages/admin/Coupons"
import { Categories as AdminCategories } from "pages/admin/Categories"
import { DeliveryMen as AdminDeliveryMen } from "pages/admin/Delivery-men"
import {
  Customers as AdminCustomers,
  AreaActive as AdminAreaActive,
  NewThisMonth as AdminNewThisMonth,
  CustomersBundles as AdminCustomersBundles,
} from "pages/admin/Customers"
import { Disputes as AdminDisputes } from "pages/admin/Disputes"
import { Campaigns as AdminCampaigns } from "pages/admin/Campaigns"
import {
  Dashboard as AdminDashboard,
  TopProductsBySell as AdminTopProductsBySell,
} from "pages/admin/Dashbaord"
import AdminOrder from "pages/admin/Orders/Order"
import AdminCategoryDetails from "pages/admin/Categories/CategoryDetails"
import AdminCouponDetails from "pages/admin/Coupons/CouponDetails"
import AdminProductDetails from "pages/admin/Products/ProductDetails"
import AdminDeliveryManDetails from "pages/admin/Delivery-men/DeliveryManDetails"
import AdminDisputeDetails from "pages/admin/Disputes/DisputeDetails"
import AdminCampaignDetails from "pages/admin/Campaigns/CampaignDetails"
import AdminSettings from "pages/admin/Settings/Settings"
import AdminOffers from "pages/admin/Offers/Offers"
import AdminOfferDetails from "pages/admin/Offers/OfferDetails"
import {  Revenue as AdminRevenue } from "pages/admin/Revenue"
import { VendorDetails, Vendors } from "pages/admin/Vendors"

const vendorProtectedRoutes = [
  { path: "/dashboard", component: <VendorDashboard /> },
  {
    path: "/dashboard/top-products-by-sell",
    component: <VendorTopProductsBySell />,
  },
  { path: "/orders", component: <VendorOrders /> },
  { path: "/orders/:id", component: <VendorOrder /> },
  { path: "/coupons", component: <VendorCoupons /> },
  { path: "/coupons/:id", component: <VendorCouponDetails /> },
  { path: "/categories", component: <VendorCategories /> },
  { path: "/categories/:id", component: <VendorCategoryDetails /> },
  { path: "/delivery-men", component: <VendorDeliveryMen /> },
  { path: "/delivery-men/:id", component: <VendorDeliveryManDetails /> },
  { path: "/customers", component: <VendorCustomers /> },
  { path: "/customers/new-this-month", component: <VendorNewThisMonth /> },
  { path: "/customers/area-active", component: <VendorAreaActive /> },
  { path: "/customers/bundles", component: <VendorCustomersBundles /> },
  { path: "/disputes", component: <VendorDisputes /> },
  { path: "/disputes/:id", component: <VendorDisputeDetails /> },
  // { path: "/campaigns", component: <VendorCampaigns /> },
  // { path: "/campaigns/:id", component: <VendorCampaignDetails /> },
  { path: "/products", component: <VendorProducts /> },
  { path: "/products/:id", component: <VendorProductDetails /> },
  // { path: "/offers", component: <VendorOffers /> },
  { path: "/offers/:id", component: <VendorOfferDetails /> },
  { path: "/settings", component: <VendorSettings /> },
  { path: "/revenue", component: <VendorRevenue /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

const adminProtectedRoutes = [
  { path: "/dashboard", component: <AdminDashboard /> },
  {
    path: "/dashboard/top-products-by-sell",
    component: <AdminTopProductsBySell />,
  },
  { path: "/orders", component: <AdminOrders /> },
  { path: "/orders/:id", component: <AdminOrder /> },
  { path: "/coupons", component: <AdminCoupons /> },
  { path: "/coupons/:id", component: <AdminCouponDetails /> },
  { path: "/categories", component: <AdminCategories /> },
  { path: "/categories/:id", component: <AdminCategoryDetails /> },
  { path: "/delivery-men", component: <AdminDeliveryMen /> },
  { path: "/delivery-men/:id", component: <AdminDeliveryManDetails /> },
  { path: "/customers", component: <AdminCustomers /> },
  { path: "/customers/new-this-month", component: <AdminNewThisMonth /> },
  { path: "/customers/area-active", component: <AdminAreaActive /> },
  { path: "/customers/bundles", component: <AdminCustomersBundles /> },
  { path: "/disputes", component: <AdminDisputes /> },
  { path: "/disputes/:id", component: <AdminDisputeDetails /> },
  // { path: "/campaigns", component: <AdminCampaigns /> },
  // { path: "/campaigns/:id", component: <AdminCampaignDetails /> },
  { path: "/products", component: <AdminProducts /> },
  { path: "/products/:id", component: <AdminProductDetails /> },
  // { path: "/offers", component: <AdminOffers /> },
  { path: "/offers/:id", component: <AdminOfferDetails /> },
  { path: "/settings", component: <AdminSettings /> },
  { path: "/revenue", component: <AdminRevenue /> },
  { path: "/vendors", component: <Vendors /> },
  { path: "/vendors/:id", component: <VendorDetails /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]


const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
]

export { vendorProtectedRoutes, adminProtectedRoutes, publicRoutes }
